
const digest = '6513eab6c33d1e797e2ee8a3958a205b264ed7699be124cdff38e1d57a6b41f9';
const classes = {"list":"_list_batku_1","item":"_item_batku_26","header":"_header_batku_33","date":"_date_batku_38","doctorsName":"_doctorsName_batku_42","content":"_content_batku_49","text":"_text_batku_53","diagnose":"_diagnose_batku_61","mainContent":"_mainContent_batku_68","controls":"_controls_batku_71","print":"_print_batku_77","edit":"_edit_batku_88","attachment":"_attachment_batku_99","link":"_link_batku_99","editActive":"_editActive_batku_105"};
const css = `._list_batku_1 {
  overflow-y: scroll;
  flex-grow: 1;
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
}
._list_batku_1::-webkit-scrollbar {
  display: block;
}
._list_batku_1::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._list_batku_1::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._list_batku_1::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._list_batku_1::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}
._list_batku_1 ._item_batku_26 {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #eaedf3;
  padding-bottom: 16px;
  padding-top: 16px;
}
._list_batku_1 ._item_batku_26 ._header_batku_33 {
  display: flex;
  flex-direction: row;
  gap: 15px;
}
._list_batku_1 ._item_batku_26 ._header_batku_33 ._date_batku_38 {
  font-size: 14px;
  color: #000000;
}
._list_batku_1 ._item_batku_26 ._header_batku_33 ._doctorsName_batku_42 {
  font-size: 14px;
  color: #000000;
}
._list_batku_1 ._item_batku_26 ._header_batku_33 ._doctorsName_batku_42 span {
  color: #9ea0a5;
}
._list_batku_1 ._item_batku_26 ._content_batku_49 {
  display: flex;
  flex-direction: row;
}
._list_batku_1 ._item_batku_26 ._content_batku_49 ._text_batku_53 {
  font-size: 14px;
  color: #000000;
  flex-grow: 1;
  max-width: calc(100% - 95px);
  margin-right: 18px;
  word-wrap: break-word;
}
._list_batku_1 ._item_batku_26 ._content_batku_49 ._text_batku_53 ._diagnose_batku_61 {
  font-size: 14px;
  color: #000000;
}
._list_batku_1 ._item_batku_26 ._content_batku_49 ._text_batku_53 ._diagnose_batku_61 span {
  color: #9ea0a5;
}
._list_batku_1 ._item_batku_26 ._content_batku_49 ._text_batku_53 ._mainContent_batku_68 {
  margin-top: 10px;
}
._list_batku_1 ._item_batku_26 ._content_batku_49 ._controls_batku_71 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding-right: 24px;
}
._list_batku_1 ._item_batku_26 ._content_batku_49 ._controls_batku_71 ._print_batku_77 {
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background: #1665d8 url("/dist/icons/v2/print-solid.svg") no-repeat center;
  background-size: 50%;
  cursor: pointer;
}
._list_batku_1 ._item_batku_26 ._content_batku_49 ._controls_batku_71 ._print_batku_77:hover {
  background: #062a60 url("/dist/icons/v2/print-solid.svg") no-repeat center;
}
._list_batku_1 ._item_batku_26 ._content_batku_49 ._controls_batku_71 ._edit_batku_88 {
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background: #1665d8 url("/dist/icons/v2/pen-edit.svg") no-repeat center;
  background-size: 50%;
  cursor: pointer;
}
._list_batku_1 ._item_batku_26 ._content_batku_49 ._controls_batku_71 ._edit_batku_88:hover {
  background: #062a60 url("/dist/icons/v2/pen-edit.svg") no-repeat center;
}
._list_batku_1 ._item_batku_26 ._attachment_batku_99 ._link_batku_99 {
  font-size: 14px;
  color: #1665d8;
  text-decoration: underline;
  cursor: pointer;
}
._list_batku_1 ._editActive_batku_105 {
  background-color: #f2f4f7;
  padding-left: 15px;
  border-left: 3px solid #1d65d8;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  